
export default {
  ResetTourData() {
    this.CurrentTourQuestionsJSON = null;
    this.QuestionsTotal = 0;
    this.QuestionsAnswered = 0;
    this.PointsGenerated = 0;
    this.AnswerAttempts = 0;
  },
  TourMode() {
    this.$emit("updateNavbar", "navbar-hidden");
    this.$emit("ModeChanged", "Tour");
    // this.Mode = "Tour";
    var win = window;
    var instance = this;
    this.$nextTick(function () {
      instance.SlideChanged(win);
    });
  },
  EndTour() {
    this.$emit("ModeChanged", "");
  },
  IsTourStart(embed) {
    if (!embed) return false;
    var res = embed.RelatedTags.filter(
      (t) => t && t.Item && t.Item.Title === "Tour"
    );
    return res.length > 0;
  },
}
